import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FiUser, FiPhone, FiSmartphone, FiSave, FiAlertCircle } from 'react-icons/fi';
import { auth as firebaseAuth } from '../firebase/config';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const Profile = ({ user, onUpdateUser }) => {
    const [bridgeNumber, setBridgeNumber] = useState(user?.bridge_number || '');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (user?.bridge_number) setBridgeNumber(user.bridge_number);
    }, [user]);

    const handleUpdate = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');
        try {
            const headers = user?.isGuest
                ? { 'x-session-id': localStorage.getItem('sessionId') }
                : { 'Authorization': `Bearer ${await firebaseAuth.currentUser?.getIdToken()}` };

            const res = await axios.post(`${API_URL}/users/update-profile`, { bridge_number: bridgeNumber }, { headers });

            onUpdateUser(res.data.user);
            setMessage('Profile updated successfully!');
            setTimeout(() => setMessage(''), 3000);
        } catch (err) {
            setMessage(err.response?.data?.message || 'Update failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="animate-fade" style={{ maxWidth: '500px', margin: '0 auto' }}>
            <h1>Your Profile</h1>

            {user?.isGuest && (
                <div className="card" style={{ marginBottom: '2rem', borderLeft: '4px solid var(--warning)', background: 'rgba(245, 158, 11, 0.05)' }}>
                    <div style={{ display: 'flex', gap: '1rem' }}>
                        <FiAlertCircle color="var(--warning)" size={24} />
                        <div>
                            <p style={{ color: 'var(--warning)', fontWeight: 600 }}>Guest User</p>
                            <p style={{ fontSize: '0.875rem' }}>Your settings will be temporary. Sign in to save them permanently.</p>
                        </div>
                    </div>
                </div>
            )}

            <div className="card">
                <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
                    <div style={{
                        width: '80px', height: '80px', background: 'var(--primary)',
                        borderRadius: '50%', margin: '0 auto 1rem', display: 'flex',
                        alignItems: 'center', justifyContent: 'center'
                    }}>
                        <FiUser size={32} color="white" />
                    </div>
                    <p style={{ fontWeight: 600, color: 'var(--text-main)' }}>{user?.email || user?.phoneNumber || 'Guest User'}</p>
                </div>

                {/* Bridge Number Hidden for now */}
                {false && (
                    <form onSubmit={handleUpdate}>
                        <div style={{ marginBottom: '1.5rem' }}>
                            <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.875rem', color: 'var(--text-muted)' }}>
                                Bridge Number (Your Phone)
                            </label>
                            <div style={{ position: 'relative' }}>
                                <FiSmartphone style={{ position: 'absolute', left: '12px', top: '14px', color: 'var(--text-muted)' }} />
                                <input
                                    value={bridgeNumber}
                                    onChange={e => setBridgeNumber(e.target.value)}
                                    placeholder="+1234567890"
                                    style={{ paddingLeft: '2.5rem', marginBottom: 0 }}
                                    required
                                />
                            </div>
                            <p style={{ fontSize: '0.75rem', marginTop: '0.5rem' }}>
                                We will call this number first whenever you use the "Bridge Call" method.
                            </p>
                        </div>

                        <button
                            type="submit"
                            className="primary"
                            style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
                            disabled={loading}
                        >
                            <FiSave /> {loading ? 'Saving...' : 'Save Settings'}
                        </button>
                    </form>
                )}

                {!false && (
                    <div style={{ textAlign: 'center', padding: '1rem', background: 'rgba(255,255,255,0.05)', borderRadius: '0.75rem' }}>
                        <p style={{ color: 'var(--text-muted)', fontSize: '0.875rem' }}>
                            Advanced call settings are currently being optimized.
                        </p>
                    </div>
                )}

                {message && (
                    <p style={{
                        color: message.includes('success') ? 'var(--success)' : 'var(--danger)',
                        textAlign: 'center', marginTop: '1rem', fontWeight: 600
                    }}>
                        {message}
                    </p>
                )}
            </div>

            <div className="card" style={{ marginTop: '2rem' }}>
                <h2>Session Info</h2>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.875rem' }}>
                    <span>User Type:</span>
                    <span style={{ color: 'var(--primary)', fontWeight: 600 }}>{user?.isGuest ? 'Guest' : 'Member'}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.875rem', marginTop: '0.5rem' }}>
                    <span>Current Balance:</span>
                    <span style={{ color: 'var(--success)', fontWeight: 600 }}>${user?.wallet_balance?.toFixed(2) || '0.00'}</span>
                </div>
            </div>
        </div>
    );
};

export default Profile;
